import Api from '../Api.js';
import BaseView from './_BaseView.js';
import Confirm from '../components/Confirm.js';
import Dropdown from '../components/Dropdown.js';
import Table from '../components/Table.js';
import trans from "../util/trans";


export default class TrashView extends BaseView {

    init() {
        super.init();
        const self = this;

        if ($('#trash').length > 0) {
            this.table = new Table('trash', '/api/guides/trashtable', [
                {data: 'select', orderable: false},
                {data: 'title'},
                {data: 'active'},
                {data: 'step'},
                {data: 'version'},
                {data: 'creator'},
                {data: 'tools', orderable: false},
            ]);

            this.menu = new Dropdown('#trashPageMenu', {
                onDelete: function (ids) {
                    if (ids.length > 0) {
                        Confirm({
                            ok: Lang.delete,
                            title: Lang.deleting,
                            msg: trans('deletex', ids.length),
                            onConfirm: function () {
                                // Guides.api.del(ids);
                                // TODO: delete multiple intead of loop below
                                $.each(ids, function (i, row) {
                                    Api.send(`/api/guides/${row}/force`, {}, 'delete').done(function () {
                                        self.table.reload();
                                    });
                                });
                            }
                        });
                    }
                },
                onExport: function (ids) {
                    const app = $('[data-app]').data('app');
                    window.location = `/api/guides/trashexport?app=${app}&ids=${ids}`;
                }
            });
        }
    }

    setEvents() {
        super.setEvents();
        const self = this;
        const section = $('#trashGroup');

        //Delete
        section.off("click.trashd").on("click.trashd", ".delete", function () {
            const id = $(this).parents('div:eq(0)').data('id');
            const name = $(this).parents('tr').find('td:eq(1)').text();

            Confirm({
                ok: Lang.delete,
                title: name,
                msg: Lang.delsure,
                onConfirm: function () {
                    Api.send(`/api/guides/${id}/force`, {}, 'delete').done(function () {
                        self.table.reload();
                    });
                }
            });
            return false;
        });
        section.off("click.trashr").on("click.trashr", ".restore", function () {
            const id = $(this).parents('div:eq(0)').data('id');
            Api.send(`/api/guides/${id}/restore`, {}, 'patch').done(function () {
                self.table.reload();
            });
            return false;
        });
    }
}